import {useState, useContext} from "react";
import './projects.scss';
import Project from "./Project";
import Button from "../Button/Button";
import LanguageContext from "../../Contexts/Language";

type ProjectProps = {
    scrollTop: number
    height: number
}
const Projects = (props: ProjectProps) =>{

    const {language} = useContext(LanguageContext);
    const [background, setBackground] = useState(0)
    const [currentType, setCurrentType] = useState(1)
    const [isChanging, setIsChanging] = useState(false)

    const ChangeType = () =>{
        setIsChanging(true);
        setBackground(background === 1 ? 0 : 1);
        setTimeout(() => {
            setIsChanging(false)
            setCurrentType(currentType === 1 ? 0 : 1);
        },500)
    }

    return(
        <div className="projects-container" style={{height: `${props.height}px`}}>
            <div className="projects-header">{language.projects.title}</div>
            <div className="button-container">
                <Button className="button" onClick={ChangeType}>{language.projects.personalButton}</Button>
                <Button className="button" onClick={ChangeType}>{language.projects.collaborativeButton}</Button>
                <div className={`buttons-background is-${background}`}/>
            </div>
            <div className={`projects-wrapper visible-${currentType === 1 ? true : false} changing-${isChanging}`}>
                    {language.projects.categories.personalProjects.length && language.projects.categories.personalProjects.map((project, key) => (
                            <Project id={key} project={project} key={key} scrollTop={props.scrollTop} visit={language.projects.visitText} modalCategories={language.projects.modalCategories} showMoreButton={language.projects.showMoreButton}/>
                    ))}
            </div>
            <div className={`projects-wrapper visible-${currentType === 0 ? true : false} changing-${isChanging}`}>
                    {language.projects.categories.collaborativeProjects.length && language.projects.categories.collaborativeProjects.map((project, key) => (
                            <Project id={key} project={project} key={key} scrollTop={props.scrollTop} visit={language.projects.visitText} modalCategories={language.projects.modalCategories} showMoreButton={language.projects.showMoreButton}/>
                    ))}
            </div>
        </div>
    )
}
export default Projects